import { baseState, baseMutations } from '@/store/mixins'
import httpClient from '@/http-client'

const BASE_URL = '/api/v2/student-transfers'

export default {
  namespaced: true,
  state: {
    ...baseState
  },
  mutations: {
    ...baseMutations
  },
  actions: {
    onGetStudent(context, params = {}) {
      return httpClient.get(`${BASE_URL}/students`, {
        params
      })
    },
    onSave(context, data) {
      return httpClient.post(`${BASE_URL}`, data)
    },
    onGetBranch(context, params = {}) {
      return httpClient.get(`${BASE_URL}/branches`, {
        params
      })
    },
    onGetToClasses(context, params = {}) {
      return httpClient.get(`${BASE_URL}/to-classes`, {
        params
      })
    },
    onGetScoreComponentEntry(context, { classId, studentId }) {
      return httpClient.get(
        `${BASE_URL}/score-component-entries/${classId}/${studentId}`
      )
    },
    onGetScoreGrading(context, { classId, studentId }) {
      return httpClient.get(`${BASE_URL}/score-grading/${classId}/${studentId}`)
    },
    onGetSubjectItem(context, gradeId) {
      return httpClient.get(`${BASE_URL}/${gradeId}/to-grades`)
    },
    onGetInvoice(context, { studentId, classId, toGradeId, branchId }) {
      return httpClient.get(
        `${BASE_URL}/${studentId}/${classId}/${toGradeId}/invoices`,
        {
          params: {
            branchId
          }
        }
      )
    },
    onGetServiceSubscription(context, { studentId, toGradeId, branchId }) {
      return httpClient.get(
        `${BASE_URL}/${studentId}/${toGradeId}/subscriptions`,
        {
          params: {
            branchId
          }
        }
      )
    }
  }
}
